import React, { useEffect, useState } from 'react';
import SimpleBarChart from './charts/SimpleBarChart';
import sourceColors from '../sourceColors.json';

function AccumulativeTonnesChart({ start, end }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!start || !end) return;
    fetch(`/api/source-tonnage.php?start=${start}&end=${end}`)
      .then(res => res.json())
      .then(res => {
        const parsed = res
          .map(r => ({
            label: r.source,
            value: parseFloat(r.total_tonnage) || 0,
          }))
          .filter(d => d.value > 0);
        setData(parsed);
      })
      .catch(() => setData([]));
  }, [start, end]);

  if (data.length === 0) {
    return <div className="flex-1 flex items-center justify-center text-sm">No data</div>;
  }

  const calcStep = val => {
    if (val === 0) return 1;
    const rough = val / 5;
    const pow = Math.pow(10, Math.floor(Math.log10(rough)));
    const mults = [1, 2, 5, 10];
    for (const m of mults) {
      if (rough <= m * pow) {
        return m * pow;
      }
    }
    return 10 * pow;
  };

  const maxVal = Math.max(...data.map(d => d.value), 0);
  const step = calcStep(maxVal);
  const tickCount = Math.ceil(maxVal / step);
  const ticks = Array.from({ length: tickCount + 1 }, (_, i) => +(i * step).toFixed(0));
  const maxAxis = tickCount > 0 ? ticks[ticks.length - 1] : step;

  const chartData = data.map(d => ({
    label: d.label,
    value: d.value,
    color: sourceColors[d.label] || '#22c55e',
    display: d.value.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }),
    valueInside: true,
  }));

  return (
    <SimpleBarChart
      key={`${start}-${end}-${data.length}`}
      height={160}
      data={chartData}
      max={maxAxis}
      ticks={ticks}
      valueClass="text-sm font-bold"
      labelFontSize={14}
      labelBold
    />
  );
}

export default AccumulativeTonnesChart;
